// components/profile/SocialLinks.jsx
import React from 'react';

const SocialLinks = ({ links = {} }) => {
  return (
    <div>
      {links.instagram && <a href={links.instagram}>Instagram</a>}
      {links.twitter && <a href={links.twitter}>Twitter</a>}
      {links.youtube && <a href={links.youtube}>YouTube</a>}
    </div>
  );
};

export default SocialLinks;